import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const HouseIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 25, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 25) / 25}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.6397 24.2267H4.36059C1.95361 24.2267 0.00012207 22.2732 0.00012207 19.8663V10.0523C0.00012207 8.63371 0.697796 7.2965 1.86059 6.48255L10.0001 0.784883C11.5001 -0.261628 13.5117 -0.261628 15.0001 0.784883L23.1397 6.48255C24.3024 7.2965 25.0001 8.63371 25.0001 10.0523V19.8663C25.0001 22.2732 23.0466 24.2267 20.6397 24.2267ZM12.5001 1.73837C11.9769 1.73837 11.4536 1.90116 11.0001 2.21511L2.86059 7.91278C2.16291 8.40115 1.74431 9.20348 1.74431 10.0523V19.8663C1.74431 21.3081 2.91873 22.4825 4.36059 22.4825H20.6397C22.0815 22.4825 23.2559 21.3081 23.2559 19.8663V10.0523C23.2559 9.20348 22.8373 8.40115 22.1397 7.91278L14.0001 2.21511C13.5466 1.90116 13.0234 1.75 12.5001 1.75V1.73837Z"
        fill="currentColor"
      />
      <path
        d="M17.1515 24.2266H7.8492C7.37246 24.2266 6.97711 23.8312 6.97711 23.3545V17.5406C6.97711 14.494 9.45386 12.0173 12.5004 12.0173C15.5469 12.0173 18.0236 14.494 18.0236 17.5406V23.3545C18.0236 23.8312 17.6283 24.2266 17.1515 24.2266ZM8.7213 22.4824H16.2794V17.5406C16.2794 15.4592 14.5818 13.7615 12.5004 13.7615C10.419 13.7615 8.7213 15.4592 8.7213 17.5406V22.4824Z"
        fill="currentColor"
      />
    </svg>
  )
})

HouseIcon.displayName = 'HouseIcon'
